import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage } from 'ui/i18n';
import { observable, action } from 'mobx';
import { getIndexForItem } from 'state/helpers';

import { ColorItem } from 'ui/components';

import './ChooseColorItem.scss';

@inject('ItemsState', 'CartItemsState')
@observer
export default class ChooseColorItem extends Component {
	static propTypes = {
		ItemsState: PropTypes.object.isRequired,
		CartItemsState: PropTypes.object.isRequired,
		items: PropTypes.object.isRequired,
		totalQuantity: PropTypes.number,
		itemNumber: PropTypes.string,
		cartItem: PropTypes.object.isRequired,
		baseItemNumber: PropTypes.string.isRequired,
		isPack: PropTypes.bool.isRequired,
		isPreview: PropTypes.bool,
		quantity: PropTypes.number.isRequired,
		onChange: PropTypes.func.isRequired,
		inEditMode: PropTypes.bool,
	};

	static defaultProps = {
		totalQuantity: 0,
		inEditMode: false,
		isPreview: false,
		itemNumber: '',
	};

	@observable quantity = 0;
	@observable nonPackTotal = 0;

	ItemsState = this.props.ItemsState;
	CartItemsState = this.props.CartItemsState;
	indexInCurrentCart = getIndexForItem(
		this.CartItemsState.cartUpdates,
		this.props.cartItem,
		this.props.cartItem.is_pack
	);

	handleOnChangeInEdit(isValid, item, value) {
		const config = {
			id: item.id,
			quantity_ordered: parseInt(value, 10),
			number: item.item_number,
			base_number: item.base_number,
			image_url: item.image_url,
		};

		if (isValid) {
			this.CartItemsState.addConfiguration(config, this.props.cartItem);
		} else {
			this.CartItemsState.deleteConfiguration(config, this.props.cartItem);
		}

		this.quantity = this.CartItemsState.getTotalQuantity(
			this.CartItemsState.cartUpdates[this.indexInCurrentCart].configurations,
			item.id
		);

		this.props.onChange(item.id, this.quantity);
	}

	@action
	handleOnChange(isValid, item, value) {
		if (this.props.inEditMode) {
			this.handleOnChangeInEdit(isValid, item, value);
		} else {
			const config = {
				id: item.id,
				quantity_ordered: parseInt(value, 10),
				number: item.item_number,
				base_number: item.base_number,
				image_url: item.image_url,
			};

			if (isValid) {
				this.CartItemsState.addConfiguration(config, this.props.cartItem);
			} else {
				this.CartItemsState.deleteConfiguration(config, this.props.cartItem);
			}

			this.quantity = this.CartItemsState.getTotalQuantity(
				this.CartItemsState.cartUpdates[this.indexInCurrentCart].configurations,
				item.id
			);

			if (!this.props.isPack && !this.props.totalQuantity) {
				this.CartItemsState.updateQuantity(
					this.indexInCurrentCart,
					this.quantity
				);
			}
			this.props.onChange(item.id, this.quantity);
		}
	}

	render() {
		const {
			items,
			totalQuantity,
			baseItemNumber,
			itemNumber,
			isPack,
			isPreview,
			quantity,
		} = this.props;
		const total = !isPack && !totalQuantity ? this.quantity : totalQuantity;

		return (
			<div className="container-fluid ChooseColorItem">
				<div className="row ChooseColorItem-header">
					{baseItemNumber}
				</div>
				<div className="row ChooseColorItem-content">
					{items.map((item, index) =>
						<div className="col-md-3 col-sm-3 col-xs-3" key={index}>
							<ColorItem
								cartItem={this.props.cartItem}
								itemNumber={itemNumber}
								item={item}
								isPack={isPack}
								isPreview={isPreview}
								totalQuantity={totalQuantity}
								inEditMode={this.props.inEditMode}
								handleOnChange={this.handleOnChange.bind(this)}
								isSoldOut={quantity <= 0}
							/>
						</div>
					)}
				</div>

				<div className="row ChooseColorItem-footer">
					{this.props.isPack &&
						!totalQuantity &&
						<div className="ChooseColorItem-footer-message">
							<FormattedMessage id="chooseColor.isPack" />
						</div>}

					<div>
						<p>
							<FormattedMessage
								id="chooseColor.selectTotalQty"
								values={{ total }}
							/>
							{this.quantity}/{total}
						</p>

						{totalQuantity > 0 &&
							this.quantity > 0 &&
							this.quantity !== totalQuantity &&
							<p className="ChooseColorItem__Error">
								<FormattedMessage
									id="chooseColor.mustSelectError"
									values={{ totalQuantity }}
								/>
							</p>}

						{!isPack &&
							!totalQuantity &&
							this.quantity > quantity &&
							<p className="ChooseColorItem__Error">
								<FormattedMessage
									id="chooseColor.itemQuantityBelowError"
									values={{ quantity }}
								/>
							</p>}
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ChooseColorItem/index.js